import angular from 'angular';

import PulseIndicatorModule from './pulse-indicator';
import SpinnerIndicatorModule from './spinner-indicator';

export default angular
    .module('common.component.loader.component', [
        PulseIndicatorModule.name,
        SpinnerIndicatorModule.name
    ]);



// WEBPACK FOOTER //
// ./src/common/component/loader/component/index.js